import { useCallback, useEffect, useState } from "react";
import {
  recordSmallerMatchIntroAck,
  shouldShowSmallerMatchIntro,
} from "./smallerMatchIntro";

const INTRO_DELAY_MS = 400;

export default function useSmallerMatchIntro({ blocked = false } = {}) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!shouldShowSmallerMatchIntro()) {
      setOpen(false);
      return undefined;
    }

    if (blocked) {
      setOpen(false);
      return undefined;
    }

    const timer = window.setTimeout(() => {
      if (shouldShowSmallerMatchIntro()) {
        setOpen(true);
      }
    }, INTRO_DELAY_MS);

    return () => window.clearTimeout(timer);
  }, [blocked]);

  const dismiss = useCallback(() => {
    recordSmallerMatchIntroAck();
    setOpen(false);
  }, []);

  return { open, dismiss };
}
